import type { TenancyTab, TenancyTabBar, UnitTab, UnitTabBar } from './scope';

type TFn = (key: string, opts?: Record<string, unknown>) => string;

/** Label of a unit tab (tab bar, breadcrumb and back button use the same words). */
export const unitTabLabel = (t: TFn, tab: UnitTab): string =>
  ({
    uebersicht: t('unit.tabs.overview'),
    mietverhaeltnisse: t('unit.tabs.tenancies'),
    zaehler: t('unit.tabs.meters'),
    konto: t('unit.tabs.account'),
    abrechnungen: t('unit.tabs.statements'),
    dokumente: t('unit.tabs.documents'),
    zeitachse: t('unit.tabs.timeline'),
    chronik: t('unit.tabs.history'),
  })[tab];

/** Label of a tenancy tab inside its unit. */
export const tenancyTabLabel = (t: TFn, tab: TenancyTab): string =>
  ({
    uebersicht: t('tenancy.tabs.overview'),
    konto: t('tenancy.tabs.account'),
    kaution: t('tenancy.tabs.deposit'),
    dokumente: t('tenancy.tabs.documents'),
    mahnung: t('tenancy.tabs.dunning'),
    nachrichten: t('tenancy.tabs.messages'),
    einstellungen: t('tenancy.tabs.settings'),
    chronik: t('tenancy.tabs.history'),
  })[tab];

/** Label of a tab in the unit's tab bar ("Mietverhältnis", "Verlauf" group several routes). */
export const unitTabBarLabel = (t: TFn, tab: UnitTabBar): string =>
  tab === 'verlauf' ? t('workspace.unitTabs.history') : tab === 'mietverhaeltnisse' ? t('workspace.unitTabs.tenancy') : unitTabLabel(t, tab);

/** Label of a tab in the tenancy's tab bar ("Konto & Mahnung" holds both views). */
export const tenancyTabBarLabel = (t: TFn, tab: TenancyTabBar): string =>
  tab === 'konto' ? t('workspace.tenancyTabs.account') : tenancyTabLabel(t, tab);
